export const SET_POSTS_COUNT = 'SET_POSTS_COUNT';
export const SET_THREAD_NAME = 'SET_THREAD_NAME';
export const SET_COMMENTS_COUNT = 'SET_COMMENTS_COUNT';
